import { useEffect } from 'react';

// Completes the mobile bit hand-off that IsraelGives leaves to the embedder.
//
// bit has two implementations on their side, picked by user-agent
// (`getPlatform()` in their direct-bit.js):
//
// - Desktop: Bank Hapoalim's SDK opens bit's payment window itself. Nothing
//   for us to do.
// - Android/iOS: the donate button posts back, their server routes the frame
//   to /directbitintegration, and that page has to send the donor to bit's
//   universal link so the bit app opens. A universal link only opens the app
//   from a TOP-LEVEL navigation — inside an iframe the OS ignores it — so when
//   their page finds itself framed it does not navigate. It posts the link out
//   to window.parent instead and expects the embedding page to do it:
//
//     { type: 'bitPaymentRedirect', deviceType: 'iOS', url: 'https://www.bitpay.co.il/app/…' }
//
// Without a listener the frame just sits on /directbitintegration, which
// renders nothing — the blank pink rectangle (.mf-iframe's own background).
//
// Leaving our page is the point, not a side effect: bit needs the top-level
// navigation. The donor comes back the same way a PayPal donor does — their
// charge completes at IsraelGives, which redirects to our `successurl`, and
// ig-complete.html reports the donation and returns them to `r` (see
// igIframe.js buildSuccessUrl).

const IG_ORIGIN = 'https://secured.israelgives.org';

// The origin check already makes a spoofed message impossible, so this is
// belt-and-braces: it keeps a bug on their side from turning our page into an
// open redirect. bit's own domain only.
const BIT_HOSTS = ['bitpay.co.il', 'www.bitpay.co.il'];

function isBitUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && BIT_HOSTS.includes(parsed.host);
  } catch (e) {
    return false;
  }
}

export function useBitRedirect() {
  useEffect(() => {
    const onMessage = (e) => {
      if (e.origin !== IG_ORIGIN) return;
      if (!e.data || e.data.type !== 'bitPaymentRedirect') return;
      if (!isBitUrl(e.data.url)) return;

      window.location.href = e.data.url;
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
}
